var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavComunicadosWhite = function SvgNavComunicadosWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_comunicados_white_svg__Capa_2",
    viewBox: "0 0 32.23 30.22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_comunicados_white_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.16 0H5.07A5.07 5.07 0 0 0 0 5.07v14.79c0 2.8 2.27 5.07 5.07 5.07H7.5v3.79c0 1.22 1.38 1.92 2.36 1.21 2.08-1.51 5.04-3.67 6.83-5h10.46c2.8 0 5.07-2.27 5.07-5.07V5.07c0-2.8-2.27-5.07-5.07-5.07Zm-1.95 16.97c0 .76-.61 1.37-1.37 1.37H8.39c-.76 0-1.37-.61-1.37-1.37v-.7c0-.76.61-1.37 1.37-1.37h15.45c.76 0 1.37.61 1.37 1.37z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.18,
    height: 3.43,
    x: 7.02,
    y: 6.47,
    rx: 1.37,
    ry: 1.37,
    fill: "#19d3c5"
  }))));
};
export default SvgNavComunicadosWhite;